import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "", to = "/", ariaLabel = "Animaverde — home" }) {
  const img = (
    <img
      src="/logo-animaverde.png"
      alt="Animaverde — cura e passione per il tuo verde"
      className={`w-auto object-contain ${className}`}
      loading="eager"
    />
  );
  if (!to) return img;
  return (
    <Link to={to} aria-label={ariaLabel} data-testid="logo-link" className="inline-flex items-center">
      {img}
    </Link>
  );
}
